/**
 * Platform Mass DM in Chats (06-10-2026, Jordy).
 *
 * Een Platform Mass DM (native campagne) deelt het platform zelf uit; onze
 * eigen verzendtelling blijft dan 0. "0/407 sent" was misleidend: toon wat we
 * wel weten — verstuurd op het platform, voor hoeveel fans, en hoeveel kopieën
 * het platform terugmeldde en in de chats staan. Zelfde regel als de server
 * (`platform_campaign_progress` in mass_message_attribution.py).
 */

export interface MassVoortgangRij {
  kind?: string | null
  status?: string | null
  recipient_count?: number | null
  sent_count?: number | null
  failed_count?: number | null
  copies_in_chats?: number | null
}

export const isPlatformCampagne = (kind: unknown): boolean =>
  String(kind ?? '').toLowerCase().includes('native')

const n = (v: unknown) => Number(v ?? 0) || 0
const fmt = (v: number) => v.toLocaleString('en-US')

export function massVoortgang(r: MassVoortgangRij): string {
  const sent = n(r.sent_count)
  const failed = n(r.failed_count)
  const total = n(r.recipient_count)
  if (isPlatformCampagne(r.kind) && sent === 0 && failed === 0) {
    const status = String(r.status ?? '').trim().toLowerCase()
    const kop = status === '' || status === 'accepted' || status === 'done'
      ? 'Sent on platform'
      : status === 'ambiguous'
        ? 'Sent on platform? (unconfirmed)'
        : status.charAt(0).toUpperCase() + status.slice(1)
    const delen = [kop]
    if (total > 0) delen.push(`${fmt(total)} fans`)
    if (n(r.copies_in_chats) > 0) delen.push(`${fmt(n(r.copies_in_chats))} in chats`)
    return delen.join(' · ')
  }
  return `${sent}/${total} sent${failed ? ` · ${failed} failed` : ''}`
}

/** Label op een Mass DM-kopie in de chat: "Mass DM · Platform" of "· Dashboard". */
export const massDmLabel = (kind: unknown): string =>
  kind == null || kind === ''
    ? 'Mass DM'
    : `Mass DM · ${isPlatformCampagne(kind) ? 'Platform' : 'Dashboard'}`
